import React, { lazy, Suspense } from "react";
import { useLocation } from 'react-router-dom';
import MastermindsHeader from './components/MastermindsHeader/MastermindsHeader';
import HomeBanner from './components/HomeBanner/homeBanner';
import AnalyticsAndWidgets from "./components/ScriptTags/widget";
import MetaHelmet from './components/MetaHelmet';
import { getMetaTags } from './utils/metaConfig';

const HomeInterior = lazy(() => import("./components/HomeInterior/homeInterior"));
const Footer = lazy(() => import("./components/FooterNew/index"));

const HomePage = () => {
  const location = useLocation();

  const meta = getMetaTags({
    pageType: 'homepage',
    domain: process.env.REACT_APP_DOMAIN,
    cdnLink: process.env.REACT_APP_CDN_LINK,
    publicUrl: process.env.PUBLIC_URL,
  });

  return (
    <div className="app" style={{ position: 'relative', minHeight: '100vh' }}>
      <AnalyticsAndWidgets />
      {location.pathname !== '/masterminds' && (
        <>
          <MetaHelmet {...meta} />
          <MastermindsHeader pageType="main" />
          <HomeBanner />
          <Suspense fallback={<div>Loading Interior...</div>}>
            <HomeInterior />
          </Suspense>
          <Suspense fallback={<div>Loading Footer...</div>}>
            <Footer />
          </Suspense>
        </>
      )}
    </div>
  );
};

export default HomePage;
